import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW5002Model } from "../kymw5002.model";
import { PlessViewUtilsSub } from "src/app/commons/kymw00/pless-view-utils-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";

/**
 * EC使用画像の登録を行う
 *
 * @export
 * @class KYMW50registImageDataService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class KYMW50registImageDataService extends PlessJsonResponderSub<any> {

  private model: KYMW5002Model = null;
  private successFunc: Function = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof KYMW50registImageDataService
   */
  getBody() {
    const request = {
      RegistImageData: {
        condition: {
          OrderCode: this.model.inputOrderCode,
          PCode: this.model.inputPcode,
        }
      },
      ImageList: {
        combination: this.model.useImageList.map(image => {
          return {
            condition: {
              ImageId: image.ImageId,
              TextCaption: image.TextCaption,
            }
          }
        })
      },
      CoopCodeList: {
        combination: this.model.selectedCoopList.map(coop => {
          return {
            condition: {
              CoopCode: coop.selectCoopCode,
            }
          }
        })
      }
    }
    if (PlessViewUtilsSub.isEmptyArray(this.model.useImageList)) delete request.ImageList;
    if (PlessViewUtilsSub.isEmptyArray(this.model.selectedCoopList)) delete request.CoopCodeList;

    return new PlessRequest({
      regist: request,
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW5002Model} model
   * @memberof KYMW50registImageDataService
   */
  execute(model: any, successFunc: Function = null) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('KYMW50registImageData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof KYMW50registImageDataService
   */
  success(data: any): void {
    if (this.successFunc) this.successFunc();
  }
}